const toPositiveInt = (value: unknown): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

const getMailchimpFlowCompanyId = (): number => {
  try {
    const flowRaw = sessionStorage.getItem('mailchimp_auth_flow');
    if (!flowRaw) return 0;
    const flow = JSON.parse(flowRaw) as { companyId?: number | string };
    return toPositiveInt(flow?.companyId);
  } catch {
    return 0;
  }
};

const getSelectedCompanyId = (): number =>
  toPositiveInt(localStorage.getItem('selectedCompanyId'));

const getCompanyIdFromReturnUrl = (returnUrl: string | null): number => {
  if (!returnUrl) return 0;
  try {
    const query = returnUrl.includes('?') ? returnUrl.split('?')[1] : '';
    const params = new URLSearchParams(query);
    return toPositiveInt(params.get('companyId'));
  } catch {
    return 0;
  }
};

export const resolveMailchimpCompanyId = ({
  preferredCompanyId = 0,
  returnUrl = null,
}: {
  preferredCompanyId?: number | string;
  returnUrl?: string | null;
}): number =>
  toPositiveInt(preferredCompanyId) ||
  getMailchimpFlowCompanyId() ||
  getCompanyIdFromReturnUrl(returnUrl) ||
  getSelectedCompanyId();
